// System Maintenance — Reset Modules test-id registry.
export const SYSTEM_MAINTENANCE = {
  page: "system-maintenance-page",
  moduleCheckbox: (key) => `sm-module-${key}`,
  requiredBadge: (key) => `sm-required-${key}`,
  requiredHint: "sm-required-hint",
  selectAll: "sm-select-all",
  clearAll: "sm-clear-all",
  dryRunBtn: "sm-dry-run-btn",
  resetBtn: "sm-reset-btn",
  factoryResetBtn: "sm-factory-reset-btn",
  dryRunResults: "sm-dry-run-results",
  dryRunTotal: "sm-dry-run-total",
  confirmModal: "sm-confirm-modal",
  confirmText: "sm-confirm-text",
  confirmPassword: "sm-confirm-password",
  confirmPasswordToggle: "sm-confirm-password-toggle",
  confirmReason: "sm-confirm-reason",
  confirmExecute: "sm-confirm-execute",
  confirmCancel: "sm-confirm-cancel",
  successBanner: "sm-success-banner",
  errorBanner: "sm-error-banner",
  navLink: "nav-system-maintenance",
};
